/* glossaryThunk.ts */

/* Redux Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Utils */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Interfaces */
import { GlossaryProps } from "src/shared/interfaces/common/Glossary";

export const fetchGlossary = createAsyncThunk<
  GlossaryProps[] | undefined
>("/data/glossary", async () => {
  try {
    const response = await axiosInterceptor.get<
      GlossaryProps[]
    >("/data/glossary");

    return response.data;
  } catch (error) {
    console.error(error);
  }
});
